import type { RouteObject } from 'react-router-dom';
import InvitationsPage from '../pages/InvitationsPage';
import InviteSignUpPage from '../pages/InviteSignUpPage';
import ReceivedInvitationPage from '../pages/ReceivedInvitationPage';
import ShareInvitationPage from '../pages/ShareInvitationPage';
import { OPEN_TO_SIGNED_OUT } from './signedOut';

/**
 * `/invite/`, not `/share/`: the server-side `/share/<token>` route (Universal
 * Links, App Links) redirects browsers here, and reusing `/share/` for both
 * would loop that redirect back on itself.
 */
export const invitationsRoutes: RouteObject[] = [
  { path: '/invite/:token', element: <ShareInvitationPage />, handle: OPEN_TO_SIGNED_OUT },
  { path: '/invite/:token/sign-up', element: <InviteSignUpPage />, handle: OPEN_TO_SIGNED_OUT },
  { path: '/invitations', element: <InvitationsPage /> },
  { path: '/invitations/received/:invitationId', element: <ReceivedInvitationPage /> },
];
